<template>
    <li :selected="selected" @mousedown="selectShade(shade);">
        <Draggable class="shade-preview" :style="{ 'background-color': color }"></Draggable>
        <span>
            <div>
                <span v-if="number">{{ number }} .</span> {{ name }}
            </div>
            <div>{{ reference }}</div>
        </span>
    </li>
</template>

<script>
import Draggable from "@/plano/components/draggable";

export default {
    components: { Draggable },
    props: {
        shade: { type: Object, required: true },
        selected: Boolean
    },
    computed: {
        name() {
            return this.shade.name;
        },
        reference() {
            const properties = this.shade.properties;
            return properties && properties.reference && properties.reference.client_ref1 && properties.reference.client_ref1.value;
        },
        color() {
            const properties = this.shade.properties;
            return properties && properties.colors && properties.colors.color && properties.colors.color.value;
        },
        number() {
            const properties = this.shade.properties;
            return properties && properties.number && properties.number.numb1 && properties.number.numb1.value;
        }
    },
    methods: {
        selectShade(shade) {
            this.$emit("selectShade", shade);
        }
    }
};
</script>

<style lang="scss" scoped>
// not scoped to <li> because it can be dragged outside
.shade-preview {
    height: 30px;
    width: 30px;
    border-radius: 30px;
    display: inline-block;
    margin-right: 10px;
    border: 1px solid black;
    user-select: none;
}
li {
    display: flex;
    height: 40px;
    justify-content: start;
    align-items: center;

    &[selected] {
        .shade-preview {
            border: 3px solid black;
        }
    }

    > :last-child {
        flex-grow: 1;
    }
}
</style>



// WEBPACK FOOTER //
// shade-list-tile.vue?2b2d55f6